import { type Editor } from '@tiptap/react';
import { InlineEditBar } from './inline-edit-bar';
import { useInlineSelectionEdit } from './use-inline-selection-edit';

/**
 * Mounts the inline AI edit flow (selection → Ask Heidi v3+) for one editor:
 * runs the controller hook and renders the floating bar while a lite prompt,
 * generation, or review is active. Inert until an edit request targets this
 * editor.
 */
export const InlineSelectionEditController = ({
  editor,
  enabled,
}: {
  editor: Editor;
  enabled: boolean;
}) => {
  const {
    phase,
    actionId,
    resultText,
    streamingText,
    intent,
    isUnanswered,
    accept,
    insertBelow,
    discard,
    reprompt,
    stop,
    viewInTranscript,
    submitPrompt,
    askInChat,
    trackFeedback,
  } = useInlineSelectionEdit(editor, enabled);

  if (!enabled || phase === 'idle') return null;

  return (
    <InlineEditBar
      editor={editor}
      phase={phase}
      intent={intent}
      actionId={actionId}
      proposedText={intent === 'insight' || resultText ? resultText : null}
      streamingText={streamingText}
      resultText={resultText}
      onAccept={accept}
      onInsertBelow={insertBelow}
      onDiscard={discard}
      onReprompt={reprompt}
      onStop={stop}
      onViewInTranscript={viewInTranscript}
      onSubmitPrompt={submitPrompt}
      isUnanswered={isUnanswered}
      onAskInChat={askInChat}
      onFeedback={trackFeedback}
    />
  );
};
